import { init } from "../init";
import { TryPage } from "../pages/try/try-page";
init(TryPage);
